import Action from './Action';
import Delete from './Delete';
import { Success, Error } from './ThreeYears';

export default { Action, Delete, Success, Error };
